import { combineReducers } from 'redux';
import navData from './navData.reducer';

export default combineReducers({
  navData,
});
